/* Mercury Computers Shopify Theme — theme.js */
(function () {
  "use strict";

  /* ---------------- Mobile nav drawer ---------------- */
  var navDrawer = document.querySelector('[data-mobile-nav]');
  document.querySelectorAll('[data-open-mobile-nav]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (navDrawer) navDrawer.setAttribute('open', '');
    });
  });
  document.querySelectorAll('[data-close-mobile-nav]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (navDrawer) navDrawer.removeAttribute('open');
    });
  });

  /* ---------------- Mobile search toggle ---------------- */
  var mobileSearchBtn = document.querySelector('[data-mobile-search-toggle]');
  var mobileSearchBar = document.querySelector('[data-mobile-search-bar]');
  if (mobileSearchBtn && mobileSearchBar) {
    mobileSearchBtn.addEventListener('click', function () {
      mobileSearchBar.classList.toggle('hidden');
      if (!mobileSearchBar.classList.contains('hidden')) {
        var input = mobileSearchBar.querySelector('input');
        if (input) input.focus();
      }
    });
  }

  /* ---------------- Hero slideshow ---------------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slide-dot]'));
    var prevBtn = root.querySelector('[data-slide-prev]');
    var nextBtn = root.querySelector('[data-slide-next]');
    var pauseBtn = root.querySelector('[data-slide-pause]');
    if (!slides.length) return;
    var index = 0;
    var playing = true;
    var timer = null;
    var interval = parseInt(root.getAttribute('data-interval') || '5000', 10);

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === index); });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }
    function next() { show(index + 1); }
    function prev() { show(index - 1); }
    function play() {
      stop();
      if (slides.length > 1) timer = setInterval(next, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d, di) {
      d.addEventListener('click', function () { show(di); if (playing) play(); });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); if (playing) play(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); if (playing) play(); });
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        playing = !playing;
        pauseBtn.innerHTML = playing
          ? '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="14" y="3" width="5" height="18" rx="1"/><rect x="5" y="3" width="5" height="18" rx="1"/></svg>'
          : '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="6 3 20 12 6 21 6 3"/></svg>';
        if (playing) play(); else stop();
      });
    }
    show(0);
    play();
  });

  /* ---------------- Product rail scroll buttons ---------------- */
  document.querySelectorAll('[data-rail]').forEach(function (rail) {
    var track = rail.querySelector('[data-rail-track]');
    var prev = rail.querySelector('[data-rail-prev]');
    var next = rail.querySelector('[data-rail-next]');
    if (!track) return;
    function amount() { return Math.round(track.clientWidth * 0.8); }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -amount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: amount(), behavior: 'smooth' }); });
  });

  /* ---------------- Wishlist toggle (local storage) ---------------- */
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('mercury_wishlist') || '[]'); } catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem('mercury_wishlist', JSON.stringify(list)); } catch (e) {}
  }
  function refreshWishlistButtons() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-wishlist-toggle');
      btn.classList.toggle('is-active', list.indexOf(id) !== -1);
      btn.setAttribute('aria-pressed', list.indexOf(id) !== -1 ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-wishlist-toggle');
    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx === -1) list.push(id); else list.splice(idx, 1);
    saveWishlist(list);
    refreshWishlistButtons();
  });
  refreshWishlistButtons();

  /* ---------------- Facets: mobile toggle ---------------- */
  var facetsPanel = document.querySelector('[data-facets]');
  var facetsOverlay = document.querySelector('[data-facets-overlay]');
  document.querySelectorAll('[data-open-facets]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (facetsPanel) facetsPanel.setAttribute('open-mobile', '');
      if (facetsOverlay) facetsOverlay.classList.add('is-open');
    });
  });
  document.querySelectorAll('[data-close-facets]').forEach(function (btn) {
    btn.addEventListener('click', closeFacets);
  });
  if (facetsOverlay) facetsOverlay.addEventListener('click', closeFacets);
  function closeFacets() {
    if (facetsPanel) facetsPanel.removeAttribute('open-mobile');
    if (facetsOverlay) facetsOverlay.classList.remove('is-open');
  }

  /* ---------------- Facets: pill + sort behavior ---------------- */
  document.querySelectorAll('[data-facet-pill]').forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (pill.hasAttribute('disabled')) return;
      var url = pill.getAttribute('data-href');
      if (url) window.location.href = url;
    });
  });
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------------- Product gallery ---------------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-dot]'));
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (mainImg && src) mainImg.src = src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      });
    });
  });

  /* ---------------- Product tabs ---------------- */
  document.querySelectorAll('[data-product-tabs]').forEach(function (root) {
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-tab-btn]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-tab-panel]'));
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab-btn');
        btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === target);
        });
      });
    });
  });

  /* ---------------- Quantity selector ---------------- */
  document.querySelectorAll('[data-qty-selector]').forEach(function (root) {
    var input = root.querySelector('input');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
    });
    if (plus) plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
    });
  });

  /* ---------------- Variant selection -> update form ---------------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-variant-value]'));
    var hiddenInput = document.querySelector(root.getAttribute('data-target'));
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.hasAttribute('disabled')) return;
        pills.forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        if (hiddenInput) hiddenInput.value = pill.getAttribute('data-variant-value');
        root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true }));
      });
    });
  });

  /* ---------------- Cart drawer via AJAX ---------------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartDrawerBody = document.querySelector('[data-cart-drawer-body]');

  function openCartDrawer() { if (cartDrawer) cartDrawer.setAttribute('open', ''); }
  function closeCartDrawer() { if (cartDrawer) cartDrawer.removeAttribute('open'); }

  document.querySelectorAll('[data-open-cart-drawer]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (window.theme && window.theme.cartType === 'page') return; // let link navigate
      e.preventDefault();
      renderCartDrawer();
      openCartDrawer();
    });
  });
  document.querySelectorAll('[data-close-cart-drawer]').forEach(function (btn) {
    btn.addEventListener('click', closeCartDrawer);
  });
  var cartOverlay = document.querySelector('[data-cart-drawer-overlay]');
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  function formatMoney(cents) {
    var value = Number(cents || 0) / 100;
    var amount = value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var amountNoDecimals = value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    var format = (window.theme && window.theme.moneyFormat) || 'Ush {{amount_no_decimals}}';
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals.replace(/\./g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(/,/g, 'X').replace(/\./g, ',').replace(/X/g, '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function renderCartDrawer() {
    if (!cartDrawerBody) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (!cart.items.length) {
          cartDrawerBody.innerHTML = '<div class="cart-drawer__empty">Your cart is empty.</div>';
          var footer = document.querySelector('[data-cart-drawer-footer]');
          if (footer) footer.classList.add('hidden');
          return;
        }
        var footer = document.querySelector('[data-cart-drawer-footer]');
        if (footer) footer.classList.remove('hidden');
        var html = '';
        cart.items.forEach(function (item) {
          var imageUrl = item.image || (item.featured_image && item.featured_image.url) || '';
          var imageHtml = imageUrl
            ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'flex\';">'+
              '<span class="cart-line__image-placeholder" style="display:none;" aria-hidden="true">Image</span>'
            : '<span class="cart-line__image-placeholder" aria-hidden="true">Image</span>';
          html += '' +
            '<div class="cart-line" data-line-key="' + escapeHtml(item.key) + '">' +
              imageHtml +
              '<div class="cart-line__info">' +
                '<div class="cart-line__title">' + escapeHtml(item.product_title) + '</div>' +
                '<div class="cart-line__price">' + formatMoney(item.final_price) + '</div>' +
                '<div class="cart-line__qty">' +
                  '<button type="button" data-cart-qty-minus aria-label="Decrease quantity">-</button>' +
                  '<span>' + Number(item.quantity || 0) + '</span>' +
                  '<button type="button" data-cart-qty-plus aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<button type="button" class="cart-line__remove" data-cart-remove>Remove</button>' +
              '</div>' +
            '</div>';
        });
        cartDrawerBody.innerHTML = html;
        var subtotalEl = document.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

        cartDrawerBody.querySelectorAll('[data-cart-qty-minus]').forEach(function (btn) {
          btn.addEventListener('click', function () { changeLineQty(btn, -1); });
        });
        cartDrawerBody.querySelectorAll('[data-cart-qty-plus]').forEach(function (btn) {
          btn.addEventListener('click', function () { changeLineQty(btn, 1); });
        });
        cartDrawerBody.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
          btn.addEventListener('click', function () { changeLineQty(btn, 0, true); });
        });
      })
      .catch(function () {
        cartDrawerBody.innerHTML = '<div class="cart-drawer__empty">Unable to load cart.</div>';
      });
  }

  function changeLineQty(btn, delta, remove) {
    var line = btn.closest('[data-line-key]');
    var key = line.getAttribute('data-line-key');
    var qtySpan = line.querySelector('.cart-line__qty span');
    var newQty = remove ? 0 : Math.max(0, (parseInt(qtySpan.textContent, 10) || 1) + delta);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { renderCartDrawer(); })
      .catch(function () {});
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  /* Intercept "add to cart" forms to use AJAX + open drawer */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (window.theme && window.theme.cartType === 'page') return; // normal submit
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () {
          renderCartDrawer();
          openCartDrawer();
        })
        .catch(function () {})
        .finally(function () {
          if (submitBtn) submitBtn.removeAttribute('disabled');
        });
    });
  });

  /* Initial cart count on load */
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    updateCartCount(cart.item_count);
  }).catch(function () {});

  /* ---------------- Sticky mobile add-to-cart bar ---------------- */
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  var atcSentinel = document.querySelector('[data-atc-sentinel]');
  if (stickyAtc && atcSentinel && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(atcSentinel);
  }
  var stickyAtcBtn = document.querySelector('[data-sticky-atc-button]');
  if (stickyAtcBtn) {
    stickyAtcBtn.addEventListener('click', function () {
      var form = document.querySelector('[data-product-form]');
      if (form) {
        var submit = form.querySelector('[type="submit"]');
        if (submit) submit.click();
      }
    });
  }


  /* ---------------- Sticky header: measure announcement bar + header height ---------------- */
  function measureHeader() {
    var root = document.documentElement;
    var bar = document.querySelector('.announcement-bar');
    var wrap = document.querySelector('.shopify-section-group-header-group');
    var barH = bar ? bar.offsetHeight : 0;
    root.style.setProperty('--announcement-h', barH + 'px');
    if (wrap) root.style.setProperty('--header-h', Math.max(wrap.offsetHeight - barH, 0) + 'px');
  }
  measureHeader();
  window.addEventListener('resize', measureHeader);
  window.addEventListener('load', measureHeader);
  document.addEventListener('shopify:section:load', measureHeader);

  /* ---------------- Request a quote: auto-fill from ?product=...&sku=...&price=...&qty=... ---------------- */
  (function () {
    var form = document.querySelector('[data-quote-form]');
    if (!form) return;
    var q = new URLSearchParams(window.location.search);
    function set(name, value) {
      var el = form.querySelector('[name="' + name + '"]');
      if (el && value) el.value = value;
    }
    var title = q.get('title') || q.get('product') || '';
    set('contact[Product]', title);
    set('contact[SKU]', q.get('sku'));
    set('contact[Price]', q.get('price'));
    set('contact[Quantity]', q.get('qty'));
    set('contact[Product link]', q.get('url'));
    var summary = document.querySelector('[data-quote-product]');
    if (summary && title) {
      summary.hidden = false;
      var t = summary.querySelector('[data-quote-product-title]');
      var m = summary.querySelector('[data-quote-product-meta]');
      var img = summary.querySelector('[data-quote-product-img]');
      if (t) t.textContent = title;
      var meta = [q.get('sku') ? 'SKU: ' + q.get('sku') : '', q.get('price') || ''].filter(Boolean).join('  \u00b7  ');
      if (m) m.textContent = meta;
      if (img && q.get('img')) { img.src = q.get('img'); img.hidden = false; }
    }
    var msg = form.querySelector('[name="contact[body]"]');
    if (msg && !msg.value && title) {
      msg.value = 'Hello Mercury, please send me a quote for: ' + title + '.';
    }
  })();


  /* ---------------- Product page: pass chosen quantity to the quote link ---------------- */
  document.querySelectorAll('[data-request-quote]').forEach(function (link) {
    link.addEventListener('click', function () {
      var qty = document.querySelector('[data-product-form] input[name="quantity"]');
      var base = link.getAttribute('href').replace(/&qty=\d+/, '');
      if (qty && qty.value) link.setAttribute('href', base + '&qty=' + encodeURIComponent(qty.value));
    });
  });

})();
